import { MinusCircle, XCircle } from "lucide-react";
import React, { MouseEvent, useEffect, useState } from "react";
import ProductContainer from "../../Components/Products/ProductContainer";
import TextBauSteine from "../../Components/TextbauSteine";
import CustomButton from "../../Components/Ui/CustomButton";
import TextInput from "../../Components/Ui/TextInput";
import ToggleButton from "../../Components/Ui/ToggleButton/ToggleButton";
import { useAuth } from "../../Store/auth-context";
import { Product } from "../../Store/interfaces";
import { useScheinContext } from "../../Store/schein-context";
import { useUIContext } from "../../Store/ui-context";
import { getMaterialList } from "../../Utils/api";

const Leistung: React.FC<{ onButtonClick: any }> = ({ onButtonClick }) => {
  const [search, setSearch] = useState("");

  const {
    products,
    setProducts,
    selectedProducts,
    setSelectedProducts,
    searchedProducts,
    searchProduct,
    fahrtBerechnen,
    distanz,
    fahrtZeit,
    endTime,
    startTime,
  } = useScheinContext();

  const { showTextbauSteine, showDialog, currentProductID } = useUIContext();

  const productSearchHandler = (text: string) => {
    searchProduct(text);
  };
  const { bearbeiter } = useAuth();
  const [isShortList, setIsShortList] = useState(true);
  const [isAutoArbeitsleistung, setIsAutoArbeitsleistung] = useState(
    localStorage.getItem("AutoArbeitsleistung") === "1" ? true : false
  );

  useEffect(() => {
    if (products.length === 0) {
      getMaterials(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // gets all materials from REST
  const getMaterials = async (all: boolean) => {
    const data = await getMaterialList(all);
    const prods: Product[] = data as Product[];
    setProducts([...prods]);
  };

  function textbauSteinSelected(text: string) {
    if (currentProductID !== 0) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      let updated = false;

      const updatedSelectedProducts = selectedProducts.map((product) => {
        if (product.id === currentProductID) {
          return {
            ...product,
            kommentar: product.kommentar
              ? product.kommentar + " " + text
              : text,
          };
        }
        return product;
      });
      setSelectedProducts(updatedSelectedProducts);

      const updatedProducts = products.map((product) => {
        if (product.id === currentProductID) {
          updated = true;
          return {
            ...product,
            kommentar: product.kommentar
              ? product.kommentar + " " + text
              : text,
          };
        }
        // Not the product we're looking for, return it as is
        return product;
      });
      setProducts([...updatedProducts]);
    }
  }

  // removes the automatic added products with ID = 53,54
  const removeAnfahrt = async () => {
    const minusAnreise: Product[] = selectedProducts.filter(
      (product) => product.id !== 1373
    );
    // const minusAnreiseAll: Product[] = minusAnreiseKm.filter(
    //   (product) => product.id === 54
    // );

    setSelectedProducts(minusAnreise);
  };
  // calculates the price of the distance and time and adds a product for each
  const calculateKmAndMin = async () => {
    let result = Math.floor(distanz * 0.65 + fahrtZeit * 0.89);
    const plusAnreise: Product[] = [
      ...selectedProducts,
      {
        artikel: "An- und Abfahrt",
        artikelgruppe: "Wegpauschalen",
        beschreibung: "",
        id: 1373,
        menge: 1,
        kommentar: "",
        vk: result,
        provisionsnehmer: bearbeiter,
        provisionstyp: "Technik",
        mwst: 19,
        provisionstypid: 1,
        customprovisionsnehmer: false,
      },
    ];
    setSelectedProducts(plusAnreise);
  };

  const check4Products = () => {
    if (selectedProducts.length < 1) {
      showDialog({
        title: "Information",
        message:
          "Weiter ohne Auswahl von Produkten/Dienstleistungen nicht möglich!",
        confirmButtonText: "OK",
        // cancelButtonText: "Abbrechen",
        onConfirm: () => {
          return false;
        },
      });
    } else {
      return true;
    }
  };

  const checkAnfahrtBevorLeave = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setAutoArbeitsleistungLocally();

    if (!check4Products()) return;

    fahrtBerechnen ? handleFahrtBerechnenCase() : handleNoFahrtBerechnenCase();
  };

  const hasProduct = (id: number) =>
    selectedProducts.some((product) => product.id === id);

  const isValidAnfahrtPauschale = () => {
    const product = selectedProducts.find((product) => product.id === 1373);
    if (!product) return false;
    const expectedPrice = Math.floor(distanz * 0.65 + fahrtZeit * 0.89);
    return product.menge === 1 && product.vk === expectedPrice;
  };

  const continueWithoutAnfahrt = () => {
    showDialog({
      title: "Bestätigung",
      message: "Möchten Sie ohne Anfahrt fortfahren?",
      confirmButtonText: "Fortfahren",
      cancelButtonText: "Abbrechen",
      onConfirm: () => onButtonClick("summary"),
      onCancel: () => {},
    });
  };

  const handleFahrtBerechnenCase = () => {
    if (!hasProduct(1373) && !hasProduct(1194)) {
      calculateKmAndMin();
      return;
    }

    if (hasProduct(1373)) {
      if (isValidAnfahrtPauschale()) {
        onButtonClick("summary");
      } else {
        //removeAnfahrt();
        showDialog({
          title: "Hinweis",
          message:
            "Anfahrtspauschale hat einen falschen/erhöhten Preis oder Menge. Sind Sie sicher?",
            confirmButtonText: "OK",
            cancelButtonText: "Abbrechen",
          onConfirm: () => {
            onButtonClick("summary");
          },        
          onCancel: () => {
          return;
        },
        });
      }
      return;
    }

    if (hasProduct(1194)) {
      onButtonClick("summary");
      return;
    }

    showDialog({
      title: "Fehler",
      message: "Bitte Anfahrt korrekt auswählen.",
      confirmButtonText: "OK",
      onConfirm: () => {
        return;
      },
    });
  };

  const handleNoFahrtBerechnenCase = () => {
    if (hasProduct(1373)) {
      removeAnfahrt();
      showDialog({
        title: "Hinweis",
        message:
          "Anfahrt wurde deaktiviert, aber Anfahrtspauschale ist ausgewählt. Bitte prüfen.",
        confirmButtonText: "OK",
        onConfirm: () => {
          return;
        },
      });
      return;
    }

    if (hasProduct(1194)) {
      onButtonClick("summary");
      return;
    }

    continueWithoutAnfahrt();
  };

  const handleSwichtBetweenMaterialLists = () => {
    try {
      getMaterials(isShortList);
      setIsShortList(!isShortList);
    } catch (error) {
      console.log("Error bei Umschalten der Listen: " + error);
    }
  };

  const removeProductFromList = (event: any, index: number) => {
    event.preventDefault();

    const minusProduct: Product[] = selectedProducts.filter(
      (product) => product.id !== index
    );

    setSelectedProducts(minusProduct);
  };

  const handleChangeAutoArbeitsleistung = () => {
    setIsAutoArbeitsleistung(!isAutoArbeitsleistung);
  };

  const getArbeitsleistungPosition = () => {
    const prod = products.find((product) => product.id === 1394);
    return prod;
  };

  const setAutoArbeitsleistungLocally = () => {
    localStorage.setItem(
      "AutoArbeitsleistung",
      isAutoArbeitsleistung ? "1" : "0"
    );
  };

  useEffect(() => {
    if (products.length === 0) return;

    const diffTime = Math.abs(startTime.getTime() - endTime.getTime());
    const laborTime = Number(Math.abs(diffTime / (1000 * 60 * 60)).toFixed(2));

    if (isAutoArbeitsleistung) {
      if (
        selectedProducts.filter((product) => product.id === 1394).length === 0
      ) {
        const prod = getArbeitsleistungPosition();
        if (prod !== undefined) {
          prod.menge = laborTime;
          prod.provisionstyp = "Technik";
          prod.provisionsnehmer = bearbeiter;

          const prods: Product[] = [...selectedProducts, prod];

          setSelectedProducts(prods);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products, isAutoArbeitsleistung, startTime, endTime]);

  return showTextbauSteine ? (
    <TextBauSteine textSelected={textbauSteinSelected} />
  ) : (
    <main className="w-[90%] mx-auto">
      <form>
        <h2 className="text-blue_royal font-bold text-2xl m-1 p-5">
          Hard & Software
        </h2>
        <fieldset className="mx-auto border-gray-300">
          <div className="grid grid-cols-1 items-center justify-center">
            {/* Suche */}
            <div className="flex justify-center items-center">
              <TextInput
                className="w-5/10"
                name="full-name"
                value={search}
                label="Suche"
                placeholder="RJ45..."
                onChange={(text: string) => {
                  setSearch(text);
                  productSearchHandler(text);
                }}
              />
              {search.length > 0 && (
                <button
                  onClick={(event) => {
                    event.preventDefault();
                    setSearch("");
                    productSearchHandler("");
                  }}
                >
                  <XCircle size={24} className="mt-7 ml-2" />
                </button>
              )}
            </div>
            {search.length > 0 && searchedProducts.length === 0 && (
              <p className="mt-2 mr-8 text-red">
                Ihre Suche ergab keine Treffer
              </p>
            )}
          </div>

          {/* Toggle Button für Materiallisten */}
          <div className="flex items-center gap-3 mt-4 justify-start">
            <span className="text-gray-700 w-60">
              {isShortList
                ? "Kurze Materialliste anzeigen"
                : "Alle Materialien anzeigen"}
            </span>
            <ToggleButton
              isChecked={isShortList}
              onToggle={handleSwichtBetweenMaterialLists}
              className="flex-shrink-0"
            />
          </div>
          {/* Toggle Button für die automatische Installationspauschale */}
          <div className="flex items-center gap-3 mt-4 justify-start">
            <span className="text-gray-700 w-60">
              {isAutoArbeitsleistung
                ? "Autom. Installationsposition"
                : "Manuell Installationsposition"}
            </span>
            <ToggleButton
              isChecked={isAutoArbeitsleistung}
              onToggle={handleChangeAutoArbeitsleistung}
              className="flex-shrink-0"
            />
          </div>
          {/* Liste der Produkte */}
          <div className="flex-colum grid grid-cols-2">
            <div className="overflow-auto max-h-[calc(100vh-30rem)] grid grid-cols-1 gap-4 mt-5">
              <ProductContainer />
            </div>
            <div className="overflow-auto max-h-[calc(100vh-30rem)] grid grid-cols-1 gap-4 mt-5 ml-5">
              <div className="align-center">
                <h2 className="text-blue_royal text-xl">Warenkorb</h2>
                {selectedProducts.length === 0 && (
                  <p>Bisher keine Produkte ausgewählt</p>
                )}
                <ul className="flex flex-col gap-4 w-full">
                  {selectedProducts.map((product: Product) => (
                    <li
                      key={product.id}
                      className="bg-gray-100 border border-gray-300 rounded-lg p-4 flex flex-col
      justify-between shadow-md transition-transform hover:scale-105"
                    >
                      {/* Produkt-Info */}
                      <div className="flex flex-col">
                        <p className="font-bold text-lg">
                          {product.menge}x | {product.artikel} (
                          {product.provisionsnehmer}) ~ {product.vk}€
                        </p>
                        <p className="text-sm text-gray-600 break-words">
                          {product.kommentar}
                        </p>
                      </div>

                      {/* Entfernen-Button */}
                      <button
                        onClick={(event) =>
                          removeProductFromList(event, product.id)
                        }
                        className="mt-3 flex items-center justify-center bg-red-500 text-black
        rounded-md p-2 hover:bg-red-600 transition-colors"
                      >
                        <MinusCircle size={20} />
                        <span className="ml-2 text-sm">Entfernen</span>
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </fieldset>

        <div className="w-full grid grid-cols-2 gap-4 mt-10">
          <CustomButton
            className="w-full"
            theme="gray"
            onClick={() => onButtonClick("info")}
          >
            Zurück
          </CustomButton>

          <CustomButton
            className="w-full"
            theme="navy"
            onClick={(e) => checkAnfahrtBevorLeave(e)}
          >
            Weiter
          </CustomButton>
        </div>
      </form>
    </main>
  );
};

export default Leistung;
